<template>
  <div v-if="payload.resource_type == 'Offer'">
    <ApplicantBlockBanner :applicant="applicantJson" @released="onBlockReleased" />
    <p><b>OFFER ONLY:</b></p>
    <div class="is-flex is-align-items-center">
      <alert-button :payload="{ id: payload.resource_id, applicant: payload.resources.applicant, position: payload.resources.position, company: payload.resources.company }" :additional_data="{ resource_type: 'Offer' }"></alert-button>
      <div class="horizontal_space"></div>
      <WhatsAppLink v-bind="offers_helper.getWhatsAppLinkPayload(payload.resources)" :blocked="isBlocked"></WhatsAppLink>
      <a @click="openWhatsappTemplatesModal" class="whatsapp-templates-link" :class="{ 'is-blocked-control': isBlocked }" :title="isBlocked ? blockedToast : 'תבניות WhatsApp'">
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 640 640" fill="#3273dc">
          <path d="M546.704 91.8909c-60.1779,-60.3078 -140.222,-93.4736 -225.475,-93.4736 -175.62,0 -318.559,142.951 -318.559,318.701 0,56.1385 14.7049,111.049 42.5675,159.297l-45.2368 165.179 168.959 -44.3391c46.5951,25.3822 99.013,38.8351 152.222,38.8351l0.129923 0c0,0 0,0 0,0 175.632,0 318.689,-142.951 318.689,-318.689 0,-85.1822 -33.1658,-165.179 -93.3437,-225.463l0.0472447 -0.0472447zm-225.381 490.423l0 0c-47.599,0 -94.2177,-12.8269 -134.895,-36.9571l-9.69697 -5.78747 -100.265 26.2562 26.7759 -97.7256 -6.27173 -10.0395c-26.6578,-42.095 -40.5714,-90.8161 -40.5714,-140.931 0,-146.081 118.832,-264.96 265.066,-264.96 70.7135,0 137.328,27.6499 187.302,77.623 49.9967,50.1266 77.4931,116.588 77.4931,187.42 -0.118112,146.187 -118.95,265.066 -264.96,265.066l0.0236223 0.0354335zm145.218 -198.463c-7.91348,-4.02761 -47.1148,-23.2326 -54.3904,-25.8901 -7.27568,-2.65751 -12.5789,-4.02761 -17.9766,4.02761 -5.26778,7.91348 -20.5869,25.8901 -25.2523,31.2642 -4.66541,5.27959 -9.28358,6.03551 -17.1971,2.0079 -7.91348,-4.02761 -33.6736,-12.4253 -64.0638,-39.5674 -23.6341,-21.0947 -39.6619,-47.2211 -44.3273,-55.1345 -4.66541,-7.91348 -0.519691,-12.3072 3.53154,-16.1931 3.66146,-3.54335 7.92529,-9.28358 11.9411,-13.949 4.02761,-4.66541 5.27959,-7.92529 7.92529,-13.3112 2.65751,-5.27959 1.35828,-9.945 -0.637803,-13.949 -2.0079,-4.0158 -17.9766,-43.2171 -24.4846,-59.1858 -6.38984,-15.6026 -13.0632,-13.4293 -17.9648,-13.701 -4.66541,-0.236223 -9.945,-0.236223 -15.201,-0.236223 -5.25597,0 -13.949,1.99609 -21.2247,9.93319 -7.27568,7.91348 -27.898,27.2602 -27.898,66.4496 0,39.2013 28.5122,77.0088 32.5161,82.4065 4.02761,5.26778 56.1621,85.7845 136.029,120.238 18.9805,8.16152 33.8036,13.0632 45.3549,16.8545 19.0987,6.0237 36.4256,5.14967 50.1266,3.12996 15.3191,-2.25593 47.1148,-19.2286 53.7881,-37.8312 6.6615,-18.6144 6.6615,-34.5359 4.66541,-37.8312 -1.88979,-3.54335 -7.15757,-5.504 -15.201,-9.57886l-0.0590558 0.0472447z"/>
        </svg>
      </a>
      <button class="button is-warning is-outlined is-small mr-2" @click="aiEvaluate" title="הערכת AI">AI</button>
      <img @click="openInternalNotes" src="/note.png" width="30px">
      <SubmissionConsentButton
        v-if="payload.resources && payload.resources.applicant"
        class="mr-2"
        :applicantId="Number(payload.resources.applicant.resource_id) || null"
        :offerId="Number(payload.resource_id) || null"
        :companyId="payload.resources.company ? (Number(payload.resources.company.resource_id) || null) : null"
        :summary="consentSummary"
        showUnknown
      />
    </div>
    <div class="vertical_space"></div>
    <a @click="changeOfferMessage" class="button is-info change_offer_status">Change Offer Message</a>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import OffersHelper from '@/custom/classes/offers_helper'
import AlertButton from '@/components/AlertButton'
import WhatsAppLink from '@/components/WhatsAppLink'
import SubmissionConsentButton from '@/components/SubmissionConsentButton'
import ApplicantBlockBanner from '@/components/ApplicantBlockBanner.vue'
import { BLOCKED_TOAST, isApplicantBlocked, markReleased } from '@/custom/helpers/applicant_block.js'
export default {
  name: 'feed-offer',
  props: ['payload'],
  data () {
    return {
      offers_helper: new OffersHelper(),
      blockedToast: BLOCKED_TOAST
    }
  },
  computed: {
    // payload.resources.applicant = Admin::V1::ApplicantSerializer json (blocked / block).
    applicantJson () {
      return (this.payload && this.payload.resources && this.payload.resources.applicant) || null
    },
    isBlocked () {
      return isApplicantBlocked(this.applicantJson)
    },
    // Feed serializer: offer.submission_consent_summary (string|null); null/absent -> "לא ידוע".
    consentSummary () {
      const p = this.payload || {}
      const o = (p.resources && p.resources.offer) || {}
      const v = p.submission_consent_summary != null ? p.submission_consent_summary : o.submission_consent_summary
      return v != null ? v : null
    }
  },
  methods: {
    onBlockReleased () {
      markReleased(this, this.applicantJson)
    },
    aiEvaluate () {
      this.create({
        designator: 'ai-evaluation-modal-' + this.payload.resource_id,
        component_name: 'AiEvaluationModal',
        data: { id: this.payload.resource_id },
        modal_title: 'הערכת AI',
        modal_width: 700,
        is_center_modal: true
      })
    },
    openWhatsappTemplatesModal () {
      if (this.isBlocked) {
        this.$utils.emit('show_toast', { text: BLOCKED_TOAST })
        return
      }
      this.create({
        designator: 'whatsapp-templates-modal-' + this.payload.resource_id,
        component_name: 'ModalOfferWhatsappTemplates',
        modal_title: 'הצעת משרה למועמד',
        modal_width: 900,
        is_center_modal: true,
        data: {
          id: this.payload.resource_id,
          applicant: this.payload.resources.applicant,
          position: this.payload.resources.position,
          company: this.payload.resources.company
        }
      })
    },
    openInternalNotes () {
      this.create({ designator: 'internal-notes-modal', component_name: 'InternalNotes', resource_type: 'Offer', resource_id: this.payload.resource_id, modal_title: 'הערות פנימיות' })
    },
    changeOfferMessage () {
      this.create({ designator: 'offer-status-modal', component_name: 'OfferStatusForm', offer_data: { id: this.payload.resource_id }, modal_title: 'Change Offer Message and Status' })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    AlertButton,
    WhatsAppLink,
    SubmissionConsentButton,
    ApplicantBlockBanner
  }
}
</script>
<style scoped>
  .is-blocked-control{
    opacity: 0.4;
    filter: grayscale(100%);
    cursor: not-allowed;
  }
  .change_offer_status{
    font-size: 10px;
  }
  .whatsapp-templates-link{
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    margin-right: 6px;
  }
</style>
